const isLate = (date) => new Date(date) <= new Date();

export default isLate;
